import React, { FC } from 'react';
import styles from './PostCard.module.scss';
import { mergeQueryParams } from 'src/lib/image-helpers';
import { Link } from 'src/components/Inputs';
import Image from 'src/components/Image';

export interface PostCardProps {
  date: string;
  image?: {
    src: string;
    alt: string;
  };
  link: string;
  // eslint-disable-next-line react/no-unused-prop-types
  tags?: string[]; // used by BlogOverviewTemplate to derive the sidebar tag list
  title: string;
}

const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

const formatDate = (dateStr: string): string => {
  if (!dateStr) return '';
  const [year, month, day] = dateStr.split('-');
  const m = parseInt(month, 10);
  const d = parseInt(day, 10);
  if (!MONTHS[m - 1]) return dateStr;
  return `${MONTHS[m - 1]} ${d}, ${year}`;
};

const UPPERCASE_TAG_WORDS = new Set(['aml', 'id', 'kyc', 'qa', 'uk']);

export const formatTag = (tag: string): string => {
  const words = tag
    .toLowerCase()
    .split('-')
    .map((word) => {
      return UPPERCASE_TAG_WORDS.has(word) ? word.toUpperCase() : word;
    })
    .join(' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
};

const PostCard: FC<PostCardProps> = ({ date, image, link, title }) => {
  return (
    <div className={styles.card}>
      {image?.src && (
        <div className={styles.imageWrapper}>
          <Image
            className={styles.image}
            isLazy
            alt={image.alt || ''}
            src={mergeQueryParams(image.src, {
              w: '800',
              h: '600',
              fit: 'fill',
              f: 'center',
            })}
          />
        </div>
      )}
      <div className={styles.body}>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.meta}>
          {date && <span className={styles.date}>{formatDate(date)}</span>}
        </div>
      </div>
      <Link href={link}>
        <a className={styles.cardLink} aria-label={title} />
      </Link>
    </div>
  );
};

export default PostCard;
